<template>
  <!-- Guides hub. The backend pre-renders this same markup into #app
       (render_guides_index_html in backend/app.py). Keep the two in sync. -->
  <div class="guide-page">
    <content-header path="/guides" />
    <main class="guide-main">
      <h1 class="guide-hub-title">{{ labels.hubTitle }}</h1>
      <p class="guide-lead">{{ labels.hubLead }}</p>
      <ul class="guide-hub-list">
        <li v-for="guide in guides" :key="guide.slug">
          <h2><router-link :to="`${prefix}/guides/${guide.slug}`">{{ guide[$locale].title }}</router-link></h2>
          <p>{{ guide[$locale].summary }}</p>
          <p class="guide-meta">{{ dates(guide) }}</p>
        </li>
      </ul>
    </main>
    <content-footer />
  </div>
</template>

<script>
import content from '../public/content/guides.json';
import { applySeo } from './i18n/head';
import { contentLabels, guideDates } from './contentPages';
import ContentHeader from './components/ContentHeader.vue';
import { localePrefix } from './i18n/locales';
import ContentFooter from './components/ContentFooter.vue';

export default {
  components: { ContentHeader, ContentFooter },
  computed: {
    // Only the guides translated into this language
    guides() {
      return content.guides.filter(g => g[this.$locale]);
    },
    labels() {
      return contentLabels(this.$locale);
    },
    prefix() {
      return localePrefix(this.$locale);
    }
  },
  watch: {
    '$route'() {
      this.updateSeo();
    }
  },
  created() {
    this.updateSeo();
  },
  methods: {
    dates(guide) {
      return guideDates(guide, this.$locale);
    },
    updateSeo() {
      applySeo({
        locale: this.$locale,
        routeBase: 'guides',
        title: this.labels.hubMetaTitle,
        description: this.labels.hubMetaDescription
      });
    }
  }
};
</script>
